<script setup lang="ts">
// Sierra's .panel: flat, a 14 px radius on a hairline. The header has an uppercase
// title, an optional subtitle, and actions on the right. `flush` drops the body's
// padding, for tables and lists that run edge to edge. `collapse` lets the header
// fold the body; `open` is the starting state.
import { computed, ref, useAttrs } from 'vue';

const props = withDefaults(defineProps<{ title?: string | undefined; subtitle?: string | undefined; flush?: boolean; grow?: boolean; collapse?: boolean; open?: boolean }>(), {
  flush: false,
  grow: false,
  collapse: false,
  open: true,
});
const shown = ref(props.open);
const attrs = useAttrs();
const toggleId = computed(() => (props.collapse && typeof attrs['data-testid'] === 'string' ? `${attrs['data-testid']}-toggle` : undefined));
</script>

<template>
  <section class="itc-panel" :class="{ 'itc-panel--grow': grow, 'itc-panel--shut': collapse && !shown }">
    <header v-if="title || $slots.actions" class="itc-panel__head">
      <div>
        <h2 v-if="title" class="itc-panel__title">
          <button v-if="collapse" type="button" class="itc-panel__toggle" :aria-expanded="shown" :data-testid="toggleId" @click="shown = !shown">
            <span class="itc-panel__chevron" :class="{ 'itc-panel__chevron--open': shown }" />
            {{ title }}
          </button>
          <template v-else>{{ title }}</template>
        </h2>
        <div v-if="subtitle" class="itc-panel__sub">{{ subtitle }}</div>
      </div>
      <div v-if="$slots.actions" class="itc-panel__actions"><slot name="actions" /></div>
    </header>
    <div v-show="!collapse || shown" :class="{ 'itc-panel__body': !flush }"><slot /></div>
  </section>
</template>
